export default __webpack_public_path__ + "static/media/alertsIcon.9e184daf.svg";